<template>
    <div class="page-container">
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="queryForm" @keyup.enter.native.prevent="fetchData()"
                    class="demo-form-inline toolbar" style="padding-bottom: 0px">
                    <el-form-item label="设备编号:">
                        <el-input v-model="deviceNo" readonly />
                    </el-form-item>
                    <el-form-item label="时间范围:" style="margin-left: 10px">
                        <el-date-picker :editable="false" v-model="queryForm.timevalue" unlink-panels type="daterange"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                            clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" plain
                            @click.native.prevent="fetchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col v-loading="loading">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="监测记录" name="third">
                        <table-base
                          :tableData="logList"
                          @page-change="pageChange"
                          :len="tabelLen"
                          :pageNum="pageNum"
                          :pageSize="pageSize">
                          <template slot="table">
                            <el-table-column prop="deviceNo" align="center" label="设备编号">
                            </el-table-column>
                            <el-table-column prop="type" align="center" label="日志类型">
                              <template slot-scope="scope">
                                <span v-if="scope.row.type == 0">上下线</span>
                                <span v-else-if="scope.row.type == 1">事件</span>
                                <span v-else-if="scope.row.type == 2">报警</span>
                                <span v-else>其他</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="info" align="center" label="消息" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="remark" align="center" label="备注" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="createdTime" align="center" label="时间" width="180">
                            </el-table-column>
                          </template>
                        </table-base>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="监测分析" name="first">
                        <div id="chartLine" ref="chartLine" style="width:100%; height:350px;">
                        </div>
                    </el-tab-pane> -->
                    <el-tab-pane label="日监测报表" name="second">
                        <table-base
                          :tableData="dayList">
                          <template slot="table">
                            <el-table-column prop="dayStr" label="日期" align="center"></el-table-column>
                            <el-table-column prop="number" label="次数" align="center"></el-table-column>
                          </template>
                        </table-base>
                    </el-tab-pane>
                    
                </el-tabs>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import echarts from "echarts";
import TableBase from "@/components/common-table";
export default {
    name: 'DeviceLogTable',
    components: { TableBase },
    props: {
        deviceNo: {// 表格数据
            type: String,
            required: true
        },
    },
    data() {
        return {
            queryForm: {
                timevalue: '',
            },
            loading:true,
            activeName:'third',
            dayList: [],
            logList:[],
            tabelLen:0,
            pageNum: 1,
            pageSize: 10,
        }
    },
    watch: {
        deviceNo(newVal, oldVal) {
            this.deviceNo = newVal;
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            console.log(this.queryForm.timevalue);
            let startTime = undefined;
            let endTime = undefined;
            if(this.queryForm.timevalue){
                startTime = this.queryForm.timevalue[0];
                endTime = this.queryForm.timevalue[1];
            }
            let param = {
                deviceNo: this.deviceNo,
                pageNum: 1,
                startQueryTime: startTime,
                endQueryTime: endTime,
                pageSize: 999,
            };
            this.loading = true;
            this.$postJson("dmc/log/queryLogByDay", param).then(res => {
                console.log(res);
                this.dayList = res.result;
                this.loading = false;
                this.showEcharts();
            });
            this.getLogList();
        },
        getLogList() {

            let startTime = undefined;
            let endTime = undefined;
            if(this.queryForm.timevalue){
                startTime = this.queryForm.timevalue[0];
                endTime = this.queryForm.timevalue[1];
            }
            let params = {
                startQueryTime: startTime,
                endQueryTime: endTime,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                deviceNo: this.deviceNo,
            };
          this.$postJson("dmc/log/queryListWithPage", params).then(res => {
            this.logList = res.result.list;
            this.tabelLen = res.result.total * 1;
          })
        },
        pageChange(val){
            this.pageNum = val;
            this.getLogList();
        },
        showEcharts() {
            let myChart = echarts.init(document.getElementById('chartLine'));
            let dataAxis = [];
            let seriesList = [];
            let maxSize = 0;
            if(this.dayList!=null){
                for(let i=this.dayList.length-1;i>=0;i--){
                    dataAxis.push(this.dayList[i].dayStr.substring(5,10));
                    seriesList.push(this.dayList[i].number);
                    if(this.dayList[i].number>maxSize){
                        maxSize = this.dayList[i].number;
                    }
                }
            }
            maxSize = (1.5 * maxSize).toFixed(0);
            window.onresize = function() {
                myChart.resize();
            };
            var option = {
                tooltip: { //悬浮显示的
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                title: {
                  text: '每日活动监测分析'
                },
                grid: {
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                },
                xAxis: {
                    data: dataAxis,
                },
                yAxis: [
                    {
                        splitLine: { show: false },
                        max: maxSize,
                        minInterval: 1,
                        axisLabel: {
                            formatter: "{value}次 "
                        }
                    }
                ],
                series: {
                    type: 'bar',
                    barWidth:'50%',
                    barMaxWidth: '20px',
                    showBackground: true,
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#83bff6' },
                            { offset: 0.5, color: '#188df0' },
                            { offset: 1, color: '#188df0' }
                        ])
                    },
                    emphasis: {
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#2378f7' },
                                { offset: 0.7, color: '#2378f7' },
                                { offset: 1, color: '#83bff6' }
                            ])
                        }
                    },
                    data: seriesList,
                }
            };
            myChart.setOption(option);

        },
    },
    mounted() {
        console.log("mounted");

        this.fetchData();
    }
}
</script>
<style lang="scss" scoped>
table {
    margin: 30px 5px;
    border-collapse: collapse;
    border: 1px solid #cccccc;
}

td {
    border: 1px solid #cccccc;
}

img {
    cursor: pointer;
}
</style>
